module.exports = __webpack_public_path__ + "media/images/icons/signature-00abc79e0847d1285d0709ab3aeee1d1.svg";